'use client';

import { useCallback, useState, useSyncExternalStore } from 'react';

import { ClientSavedTicket } from '@j-s/dr-shared';

import { closeTicketByClient } from '../services/contactMessageService';
import {
  getSavedTickets,
  removeSavedTicket,
  subscribeTicketStorage,
} from '../services/ticketStorageService';

const SERVER_SNAPSHOT: ClientSavedTicket[] = [];

export function useClientTickets() {
  const savedTickets = useSyncExternalStore(
    subscribeTicketStorage,
    getSavedTickets,
    () => SERVER_SNAPSHOT
  );

  const [activeTrackingId, setActiveTrackingId] = useState<string | null>(null);
  const [activeTrackingToken, setActiveTrackingToken] = useState<string | null>(
    null
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openTicket = useCallback((id: string, token?: string) => {
    setActiveTrackingId(id);
    setActiveTrackingToken(token || null);
    setIsModalOpen(true);
    setIsDrawerOpen(false);
  }, []);

  const closeTicketModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const removeTicket = useCallback(
    (id: string) => {
      closeTicketByClient(id).catch((err) => {
        console.warn('Failed to close ticket on removal:', err);
      });
      removeSavedTicket(id);
      if (activeTrackingId === id) {
        setIsModalOpen(false);
        setActiveTrackingId(null);
        setActiveTrackingToken(null);
      }
    },
    [activeTrackingId]
  );

  return {
    savedTickets,
    ticketCount: savedTickets.length,
    activeTrackingId,
    activeTrackingToken,
    isDrawerOpen,
    setIsDrawerOpen,
    isModalOpen,
    setIsModalOpen,
    openTicket,
    closeTicketModal,
    removeTicket,
  };
}
